import {
  addLikeToMymeAPI,
  addReviewToMymeAPI,
  GETMymeDetails,
  getMymeDetailsAPI,
  GETMymeReviews,
  getMymeReviewsAPI,
  GETReportReasons,
  getReportReasonsAPI,
  POSTAddReviewToMymeRequestBody,
  removeLikeFromMymeAPI,
  removeReviewFromMymeAPI,
  ReportItemReqBody,
  reportMymeAPI,
  ReportMymeData,
  reportReviewAPI,
  ReportReviewData
} from '@myme/api';
import {
  DefaultPOSTorPATCHResType,
  Pagination,
  sendRequest,
  transformPaginationToSearchParams,
  UUID
} from '@myme/utils';

const getMymeIdRecord = (mymeId: UUID) => ({
  key: 'mymeId',
  value: mymeId
});

/* **** POST **** /reviews */
export const addReviewToMyme = async (reqBody: POSTAddReviewToMymeRequestBody) =>
  sendRequest<DefaultPOSTorPATCHResType, POSTAddReviewToMymeRequestBody>(addReviewToMymeAPI, { reqBody });

/* **** POST **** /user-likes/:mymeId */
export const addLikeToMyme = async (mymeId: UUID) =>
  sendRequest<DefaultPOSTorPATCHResType, null>(addLikeToMymeAPI, {
    args: [getMymeIdRecord(mymeId)]
  });

/* **** POST **** /user-reports/myme/:mymeId */
export const reportMyme = async (data: ReportMymeData) =>
  sendRequest<DefaultPOSTorPATCHResType, ReportItemReqBody>(reportMymeAPI, {
    reqBody: { reportId: data.reportId },
    args: [getMymeIdRecord(data.mymeId)]
  });

/* **** POST **** /user-reports/reviews/:reviewId */
export const reportReview = async (data: ReportReviewData) =>
  sendRequest<DefaultPOSTorPATCHResType, ReportItemReqBody>(reportReviewAPI, {
    reqBody: { reportId: data.reportId },
    args: [{ key: 'reviewId', value: data.reviewId }]
  });

/* **** DELETE **** /reviews/:reviewId */
export const removeReviewFromMyme = async (reviewId: UUID) =>
  sendRequest<null, null>(removeReviewFromMymeAPI, { args: [{ key: 'reviewId', value: reviewId }] });

/* **** DELETE **** /user-likes/:mymeId */
export const removeLikeFromMyme = async (mymeId: UUID) =>
  sendRequest<null, null>(removeLikeFromMymeAPI, {
    args: [getMymeIdRecord(mymeId)]
  });

/* **** GET **** /myme/:mymeId/details */
export const getMymeDetails = async (mymeId: UUID) =>
  sendRequest<GETMymeDetails, null>(getMymeDetailsAPI, {
    args: [getMymeIdRecord(mymeId)]
  });

/* **** GET **** /reviews/:mymeId */
export const getMymeReviews = async (mymeId: UUID, pagination: Pagination) =>
  sendRequest<GETMymeReviews, null>(getMymeReviewsAPI, {
    args: [getMymeIdRecord(mymeId)],
    queryStringParams: transformPaginationToSearchParams(pagination)
  });

/* **** GET **** /reports-list */
export const getReportReasons = async () => sendRequest<GETReportReasons, null>(getReportReasonsAPI);
